import React, { FC } from "react";
import styled from "@emotion/styled";
import { Button } from "antd";
import { EditOutlined, ExclamationCircleFilled } from "@ant-design/icons";
import { GetOrderDetailItem } from "services/interface";

interface SelfTrackingPendingCardProps {
  /** ชิ้น "ส่งเอง" ที่ยังไม่มีเลขพัสดุ */
  items: GetOrderDetailItem[];
  /** ออเดอร์ผสม — ยังมีชิ้นส่งกับแบ่งเบาที่ต้องเรียกขนส่ง */
  hasPlatformItems: boolean;
  /** เปิดหน้าจอกรอกเลขพัสดุ (กรอกรวมทุกชิ้นในครั้งเดียว) */
  onOpen: () => void;
}

/**
 * การ์ดแจ้งชิ้น "ส่งเอง" ที่ยังไม่มีเลขพัสดุ ใน ModalOrderDetail (แถบเตรียมจัดส่ง)
 * บอกจำนวนชิ้นที่ค้าง ทำไมต้องกรอก และกรอกแล้วเกิดอะไร — กรอกรวมทุกชิ้นจากปุ่มเดียว
 */
const SelfTrackingPendingCard: FC<SelfTrackingPendingCardProps> = ({ items, hasPlatformItems, onOpen }) => {
  if (items.length === 0) return null;

  return (
    <Card role="region" aria-label="รายการส่งเองที่รอกรอกเลขพัสดุ">
      <Header>
        <Title>
          <ExclamationCircleFilled style={{ color: "#fa8c16" }} />
          รอกรอกเลขพัสดุ (ส่งเอง)
        </Title>
        <Count>{items.length} รายการ</Count>
      </Header>

      <Description>
        สินค้าที่ร้านส่งเอง กรอกเลขพัสดุจากบริษัทขนส่งที่ใช้ส่ง ลูกค้าจะติดตามพัสดุได้
        และเมื่อกรอกครบ รายการจะย้ายไปแถบระหว่างจัดส่ง
        {hasPlatformItems && " ส่วนชิ้นที่ส่งกับแบ่งเบา ยังต้องกดเรียกขนส่งจากหน้าตารางตามเดิม"}
      </Description>

      <Button type="primary" icon={<EditOutlined />} block onClick={onOpen}>
        กรอกเลขพัสดุ
      </Button>
    </Card>
  );
};

export default SelfTrackingPendingCard;

const Card = styled.section`
  margin-bottom: 12px;
  padding: 12px 14px 14px;
  background: #fffaf3;
  border: 1px solid #ffe7ba;
  border-left: 3px solid #fa8c16;
  border-radius: 6px;
`;

const Header = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
`;

const Title = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 600;
  color: #ad4e00;
`;

const Count = styled.span`
  font-size: 12px;
  color: #8c8c8c;
  white-space: nowrap;
`;

const Description = styled.p`
  margin: 4px 0 12px;
  font-size: 13px;
  line-height: 1.55;
  color: #595959;
  max-width: 60ch;
`;
